const UserList = () => {
    return (
        <>
            <h2>User Page</h2>
            <p>이곳은 작업자관리 페이지입니다.</p>
        </>
    );
};

export default UserList;
